import { prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toTextFromProp } from '../fields/text';
import { relatedPushs } from '../partials/related-push';
import { processSlices } from '../slices';
import customSliceMapper from '../slices/postmen';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicPostmen
 */

/**
 * @typedef {DocumentSchema} PostmenSchema
 */

const processCustomSlices = processSlices(customSliceMapper);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicPostmen} data
 * @return {PostmenSchema}
 */
const processPostmen = (data) => {
  return compact({
    uid: DocumentType.POSTMEN,
    type: DocumentType.POSTMEN,
    title: toTextFromProp('title', data),
    chapeau: prop('chapeau', data),
    relatedPushs: relatedPushs(data),
    body: processCustomSlices(prop('slices', data)),
    filters: compact({
      [FILTER.MENU]: MENU.IDENTITY,
    }),
  });
};

/**
 * Normalizr schema representing a postmen page
 */
export const Postmen = deprecatedPageEntity(DocumentType.POSTMEN, {
  processStrategy: (entity) => ({
    ...processPostmen(prop('data', entity)),
  }),
});
